/*
 * @Author: wangweixin@threatbook.cn
 * @Date: 2017-12-15 11:01:33
 * @Last Modified by: wangweixin@threatbook.cn
 * @Last Modified time: 2018-10-10 10:53:54
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import validate from './validators'
import classNames from 'classnames'
import formDataMap from './formDataMap'

/**
 * 单个表单元素
 * 自带样式，规则验证等
 * 直接填充表单组件的内容即可
 */
export default class FormItem extends Component {
  state = {
    hasError: false
  }
  componentWillMount() {
    const { data, field, id } = this.props
    const fieldData = data[field]
    this.id = id
    this.trigger = fieldData ? (fieldData.trigger || 'input') : 'input'
    if (!field) {
      return
    }
    if (!fieldData) {
      throw new Error(`data中缺少正确的field：${field}`)
    }
    const { value, validators } = fieldData
    this.validators = validators
    this.handleInput(value, true)
    this.field = field
    this.isRequired = validators
      ? validators.some(validator => {
        return validator.required
      })
      : false
  }
  componentWillReceiveProps = (nextProps) => {
    const { data, field } = this.props
    const fieldData = data[field]
    if (JSON.stringify(nextProps.data[field]) !== JSON.stringify(fieldData)) {
      this.handleInput(nextProps.data[field].value, true)
    }
    if (nextProps.reset) {
      this.handleInput(nextProps.data[field].value, true)
    }
  }
  componentDidMount = () => {
    this.props.onMount(this)
  }
  validateItem(value) {
    const { validators } = this
    const curDataMap = formDataMap.get(this.id)
    if (!validators) {
      return true
    }
    return !validators.some(rule => {
      if (Array.isArray(value)) {
        if (rule.required) {
          return !validate(value, rule)
        }
        return value.some(i => {
          return !validate(i, rule, curDataMap)
        })
      }
      return !validate(value, rule, curDataMap)
    })
  }
  handleInput = (value, first) => {
    const { field, onChange } = this.props
    let isOk = this.validateItem(value, 'input')
    if (this.trigger === 'input') {
      if (!isOk && !first) {
        this.setState({
          hasError: true
        })
      } else {
        this.setState({
          hasError: false
        })
      }
    }
    formDataMap.setByItemKey(this.id, field, value)
    onChange && onChange(value)
    return isOk
  }
  handleBlur = (e) => {
    const value = e.target.value
    const { field } = this.props
    if (this.trigger !== 'blur') return
    const isOk = this.validateItem(value)
    this.setState({
      hasError: !isOk
    })
    formDataMap.setByItemKey(this.id, field, value)
  }
  renderChildren() {
    const { children, placeholder, data, field, showInfo } = this.props
    const { hasError } = this.state
    const { value } = data[field] || {}

    if (showInfo) {
      return <div className="form-item-info">
        {value}
      </div>
    }
    return children ? React.cloneElement(children, {
      onChange: this.handleInput,
      onBlur: this.handleBlur,
      defaultValue: value,
      placeholder,
      hasError
    }) : ''
  }
  render() {
    const { label, labelWidth = '100px', labelStyle, className, style, hasColon } = this.props
    const { hasError } = this.state
    const lwidth = labelWidth.indexOf('px') > 0 ? labelWidth : labelWidth + 'px'
    const classes = classNames('form-group form-item-group', className)
    const labelClasses = classNames('form-item-title-label', {
      required: this.isRequired,
      hasColon
    })
    return (
      <div className={classes} style={style}>
        <div className={labelClasses}
          style={{ flex: `0 0 ${lwidth}`, ...labelStyle }}>
          <span>{label}</span>{hasColon ? ' :' : ''}
        </div>
        <div className={`form-item-input ${hasError ? 'has-error' : ''}`}>
          {this.renderChildren()}
        </div>
      </div>
    )
  }
}
FormItem.displayName = 'FormItem'
FormItem.defaultProps = {
  trigger: 'input',
  hasColon: true
}
FormItem.propTypes = {
  /** 表单元素的标签 */
  label: PropTypes.any,
  /** 标签宽度 */
  labelWidth: PropTypes.string,
  /** 标签的特殊样式 */
  labelStyle: PropTypes.object,
  /**
   * 标签对应的field, 即最终数据中的属性
   * 若data中包含对应field的defaultValue,validators
   * 后续可不用传入
   */
  field: PropTypes.string.isRequired,
  /** 默认值 */
  defaultValue: PropTypes.any,
  /** 验证规则 */
  validators: PropTypes.array,
  /** placeholder */
  placeholder: PropTypes.string,
  /** 是否有冒号 */
  hasColon: PropTypes.boolean
}
